import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import theme from "shared/theme";
import { COLOR_BLACK_TRANSPARENT } from "shared/theme/colors";
import { flex, text } from "shared/theme/mixins";

export const StyledWrapper = styled(Box)`
  ${flex({ jc: "space-between", ai: "flex-start" })};
  margin-bottom: 1rem;
`;

export const StyledNavLink = styled(Link)`
  text-decoration: unset;
  ${text(theme.typography.bodyMSemiBold)};
  color: ${COLOR_BLACK_TRANSPARENT(0.4)};
`;

export const StyledLastTitle = styled(Typography)`
  ${text(theme.typography.bodyMSemiBold)};
  color: ${COLOR_BLACK_TRANSPARENT(0.4)};
`;
